import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/filters/sales-invoice/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const salesInvoices = {
  get: apiPathFunc(pathBase),
} as const;
